import { render, staticRenderFns } from "./BackLog.vue?vue&type=template&id=241e8ef6&scoped=true&"
import script from "./BackLog.vue?vue&type=script&lang=js&"
export * from "./BackLog.vue?vue&type=script&lang=js&"
import style0 from "./BackLog.vue?vue&type=style&index=0&id=241e8ef6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e8ef6",
  null
  
)

export default component.exports